<template>
  <router-view name="role" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "Role",
};
</script>
